import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDollarSquare = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.782 3h8.435C19.165 3 21 5.082 21 8.027v7.947C21 18.92 19.165 21 16.216 21H7.782C4.834 21 3 18.92 3 15.974V8.027C3 5.082 4.842 3 7.782 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.652 10.214c0-.749-.607-1.357-1.356-1.357H10.99a1.639 1.639 0 0 0 0 3.277h2.09a1.574 1.574 0 1 1 0 3.149h-2.372c-.75 0-1.356-.608-1.356-1.357M12 7.718v8.564"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDollarSquare);
export default ForwardRef;
